var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLovely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5743 12.4267C12.481 10.92 10.7343 9.93335 8.72099 9.93335C5.37432 9.93335 2.6543 12.6533 2.6543 16C2.6543 19.3467 5.37432 22.0667 8.72099 22.0667C10.9743 22.0667 13.0677 20.88 14.2277 18.9467L16.001 16L17.761 13.0533C18.921 11.12 21.0143 9.93335 23.2677 9.93335C26.6143 9.93335 29.3343 12.6533 29.3343 16C29.3343 19.3467 26.6143 22.0667 23.2677 22.0667C21.2677 22.0667 19.521 21.08 18.4143 19.5733",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLovely);
export default __webpack_public_path__ + "static/media/ico_lovely.e70bcca86e703ce386c6ce576c0fcdc8.svg";
export { ForwardRef as ReactComponent };